import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { Card } from "semantic-ui-react";
import { getWhatsNew, setWhatsNewRead } from "../api/whats-new";
import PageLoader from "../components/PageLoader";
import { Page, PageHeader } from "../components/ui";
import { useAuth } from "../contexts/AuthContext";

function WhatsNew() {
  const { setApiUser } = useAuth();

  const whatsNewWuery = useQuery(
    ["whats-new"],
    () => {
      return getWhatsNew();
    },
    {
      keepPreviousData: true,
      cacheTime: 3600000, // one hour
      staleTime: 600000, // 10 mins
    },
  );

  useEffect(() => {
    setWhatsNewRead().then((r) => setApiUser(r.data?.data));
  }, [setApiUser]);

  if (whatsNewWuery.isFetching) return <PageLoader>Loading...</PageLoader>;

  return (
    <Page maxWidth={960}>
      <PageHeader title="What's New" />

      {whatsNewWuery.data?.data?.data.length === 0 && (
        <WhatsNewCard
          data={{
            title: "New features and updates are on their way!",
            body: "<p>Welcome to our 'What's New' page! While we don't have any updates to share just yet, we're constantly working behind the scenes to bring you exciting changes and improvements.</p><p>Stay tuned for future announcements. We can't wait to share our latest developments with you soon!<p>",
          }}
        />
      )}

      {whatsNewWuery.data?.data?.data.map((x, i) => (
        <WhatsNewCard key={i} data={x} />
      ))}
    </Page>
  );
}

function WhatsNewCard({ data }) {
  return (
    <Card fluid style={{ margin: 0 }}>
      <Card.Content style={{ padding: "18px 20px", lineHeight: 1.6 }}>
        <Card.Header>{data.title}</Card.Header>
        <div
          style={{ marginTop: "12px" }}
          dangerouslySetInnerHTML={{ __html: data.body }}
        />
      </Card.Content>
    </Card>
  );
}

export default WhatsNew;
